// components/layout/GlobalModal.js
"use client";

import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Modal from "./Modal"; // Your existing modal component

let showFn = null;

// This function can be called from anywhere
export const showGlobalModal = ({ title, message, type = "error" }) => {
  if (showFn) {
    showFn({
      show: true,
      type,
      title,
      message,
      showButton: false, // Always hide button for global modal
    });
  } else {
    // Retry once after a short delay if not ready yet
    setTimeout(() => {
      if (showFn) {
        showFn({
          show: true,
          type,
          title,
          message,
        });
      } else {
        console.warn("Global modal not ready after retry");
      }
    }, 100); // 100ms delay
  }
};

const GlobalModal = () => {
  const [modalProps, setModalProps] = useState({
    show: false,
    type: "error",
    title: "",
    message: "",
  });

  useEffect(() => {
    showFn = setModalProps;
    return () => {
      showFn = null;
    };
  }, []);

  const handleClose = () => {
    setModalProps((prev) => ({ ...prev, show: false }));
  };

  return ReactDOM.createPortal(
    <Modal {...modalProps} onClose={handleClose} />,
    document.body
  );
};

export default GlobalModal;
